import type { AssignResourceType } from "@/service/base.service";
import type { StudentListType } from "@/types/student.model";

/**
 * Map StudentTypeSelect + dropdown selection to /stdnt/api/v2/list resource params:
 * - course → gradeId
 * - class → classId
 * - all → gradeId or classId from the selected option's kind
 */
export function toStudentListResourceParams(
  listType: StudentListType,
  selectedId?: string | null,
  selectedKind?: AssignResourceType | null
): { gradeId?: string; classId?: string } {
  const id = selectedId?.trim();
  if (!id) return {};

  if (listType === "class") return { classId: id };
  if (listType === "course") return { gradeId: id };

  if (selectedKind === "class") return { classId: id };
  return { gradeId: id };
}
